// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"Image_imgContainer__3pcIw","zoomImgOnHover":"Image_zoomImgOnHover__2KjPS","loader":"Image_loader__uHBX-"};